import { EXTENDED_TIMEOUT } from 'constants/request';
import i18n from 'app/utils/i18n';
import { AxiosResponse } from 'axios';

export function getExtendedTimeout(multiplier = 1) {
  return EXTENDED_TIMEOUT * multiplier;
}

function getApiUserErrorMessage(response?: AxiosResponse) {
  if (Array.isArray(response?.data?.errors)) {
    return response.data.errors
      ?.map((error: { message?: string }) => error?.message || '')
      .join(' ');
  }

  return (
    Object.values(response?.data?.errors ?? {})
      .flatMap((item) => item)
      .join(' ') || i18n.t('somethingWentWrong')
  );
}

export function getUserMessage(response: AxiosResponse | undefined) {
  let userMessage;

  if (response?.data?.error_msg) {
    userMessage = Array.isArray(response.data.error_msg)
      ? response.data.error_msg.join(', ')
      : response.data.error_msg;
  }

  if (typeof response?.data?.message === 'string') {
    userMessage = response?.data?.message;
  }

  if (typeof response?.data?.data?.message === 'string') {
    userMessage = response?.data?.data?.message;
  }

  if (response?.data?.user_error_msg) {
    userMessage = response?.data?.user_error_msg;
  }

  if (response?.data.errors) {
    userMessage = getApiUserErrorMessage(response);
  }

  if (response?.data?.error?.message) {
    userMessage = response.data.error.message;
  }

  return userMessage;
}

export async function getUserMessageFromBlob(
  data: unknown,
): Promise<string | undefined> {
  if (!(data instanceof Blob)) return undefined;
  try {
    const text = await data.text();
    const parsed = JSON.parse(text);
    return getUserMessage({ data: parsed } as AxiosResponse);
  } catch {
    return undefined;
  }
}
